import { IconProps } from "./type";

const MailIcon = ({ className }: IconProps) => {
  return (
    <svg
      className={className}
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 12H1.5C0.67 12 0 11.33 0 10.5V1.5C0 0.67 0.67 0 1.5 0H14.5C15.33 0 16 0.67 16 1.5V10.5C16 11.33 15.33 12 14.5 12ZM1.5 1C1.22 1 1 1.22 1 1.5V10.5C1 10.78 1.22 11 1.5 11H14.5C14.78 11 15 10.78 15 10.5V1.5C15 1.22 14.78 1 14.5 1H1.5Z"
        fill="currentColor"
      />
      <path
        d="M7.99943 7.96012C7.29944 7.96012 6.65943 7.68012 6.17943 7.17012L0.929435 1.59012C0.739435 1.39012 0.749435 1.07012 0.949435 0.880119C1.14944 0.690119 1.46943 0.700119 1.65943 0.900119L6.90943 6.48012C7.47943 7.09012 8.51944 7.09012 9.08944 6.48012L14.3394 0.910119C14.5294 0.710119 14.8494 0.700119 15.0494 0.890119C15.2494 1.08012 15.2594 1.40012 15.0694 1.60012L9.81944 7.18012C9.33944 7.69012 8.69943 7.97012 7.99943 7.97012V7.96012Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default MailIcon;
